// src/theme/ThemeContext.js
import React, { createContext, useState, useEffect, useContext, useMemo } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { themes } from '../theme'; // Upewnij się, że ścieżka do Twoich motywów jest poprawna
import apiClient from '../services/api';

// Tworzymy kontekst z domyślnymi wartościami
const ThemeContext = createContext({
    themeName: 'pure', // Domyślny motyw
    setTheme: () => {}, // Pusta funkcja jako placeholder
});

// Hook ułatwiający korzystanie z kontekstu w innych komponentach
export const useCustomTheme = () => useContext(ThemeContext);

// Główny komponent dostawcy motywu
export const CustomThemeProvider = ({ children }) => {
    const [themeName, setThemeName] = useState('pure');
    const [isLoading, setIsLoading] = useState(true);

    // Przy pierwszym ładowaniu aplikacji, pobieramy aktywny motyw z backendu
    useEffect(() => {
        const fetchActiveTheme = async () => {
            try {
                const response = await apiClient.get('/settings/active-theme');
                setThemeName(response.data.themeName || 'pure');
            } catch (error) {
                console.error("Nie udało się pobrać motywu, używam domyślnego.", error);
                setThemeName('pure');
            } finally {
                setIsLoading(false);
            }
        };

        fetchActiveTheme();
    }, []);

    // Funkcja, której będziemy używać w panelu admina do zmiany motywu
    const setTheme = (newThemeName) => {
        setThemeName(newThemeName);
    };

    // Memoizacja zapobiega niepotrzebnym re-renderom
    const activeTheme = useMemo(() => themes[themeName] || themes['pure'], [themeName]);

    // Wyświetlamy ekran ładowania, dopóki motyw nie zostanie pobrany
    if (isLoading) {
        return <div style={{textAlign: 'center', padding: '50px', fontSize: '1.2rem', fontFamily: 'sans-serif'}}>Ładowanie motywu...</div>;
    }

    return (
        <ThemeContext.Provider value={{ themeName, setTheme }}>
            <StyledThemeProvider theme={activeTheme}>
                {children}
            </StyledThemeProvider>
        </ThemeContext.Provider>
    );
};